// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"55af759f","315":"03110a6a","409":"5cddcaee","588":"248c4b9a","631":"8e97cd84","774":"55cf9b0d","787":"920a364f","965":"b8fe0ce5"}[chunkId] + ".chunk.js";
};